import Theme from 'Theme';
import styled, { css } from 'styled-components';

export const Label = styled.div`
  font-size: 0.9em;

  font-weight: 400;
  margin-bottom: 4px;

  color: rgb(1, 52, 83);
  transition: top 0.1s ease-out;
  font-family: ${Theme.primaryFont};

  ${({ error }) =>
    error &&
    css`
      color: ${Theme.dangerColor};
    `};
`;

export const InputContain = styled.div`
  display: flex;
  background-color: ${(props) => props.backgroundColor || ''};
`;

export const TextContain = styled.div`
  position: relative;
  margin-bottom: 12px;
`;

export const Required = styled.span`
  font-weight: 400;
  font-size: 1.2em;
  position: relative;
  left: 2px;
  color: #F44336;
`;

export const TextInput = styled.input`
  max-width: calc(100% - 2em);
  display: block;
  flex: 1;
  padding: 0.6em 1em;
  font-size: 1em;
  line-height: 1.2em;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  box-shadow: 0px 0px 0px 1px #c7d7e1;
  border: none;
  border-radius: 0.25rem;
  font-family: ${Theme.primaryFont};

  ${props => props.disabled && `
    background-color: #f5f6f7;
    color: #8a8a8a;
    box-shadow: 0px 0px 0px 1px #d8d8d8;
  `}

  ${(props) =>
    props.removeRightBorderRadius &&
    `
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    `}

  ${(props) =>
    props.error &&
    `
    box-shadow: 0px 0px 0px 1px ${props.theme.dangerColor};
  `};

  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    box-shadow: 0px 0px 2px 1px ${(props) => props.theme.brandColor};
  }

  ::placeholder {
    font-weight: 300;
    color: rgb(158, 171, 180);
  }
`;
